import Accordion from '@/common/components/Accordion';
import { formatTimezoneAcronym } from '@/common/services/calendarTimezoneTransformer';
import { EstablishmentCompanyData } from '@/common/types/establishment/company.type';
import { CircleChevronDownIcon, SquareCheckIcon, SquareX } from 'lucide-react';
import { UpdateGeneralPoliticsModal } from '../../Update/components/UpdateGeneralPoliticsModal';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import Spinner from '@/common/components/Spinner';
import { useEffect, useState } from 'react';

const GeneralPoliticsSection = ({ establishmentCompany }: { establishmentCompany?: EstablishmentCompanyData }) => {
  const { id } = useParams();

  const [displayFetching, setDisplayFetching] = useState(false);

  const isMutating = useIsMutating();
  const isFetching = useIsFetching({ queryKey: ['establishmentCompany', id] })

  useEffect(() => {
    isMutating && setDisplayFetching(true)
  }, [isMutating]);

  useEffect(() => {
    !isFetching && setDisplayFetching(false)
  }, [isFetching]);

  return (
    <Accordion
      defaultOpen
      head={(
        <div className="flex items-center gap-x-3">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateGeneralPoliticsModal establishmentCompany={establishmentCompany} isFetching={displayFetching && !!isFetching} />
          </div>

          <p className='text-xl'>
            Geral
          </p>

          {displayFetching && !!isFetching && <Spinner className='fill-white-400 size-4' />}
        </div>
      )}
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={(
        <div className='flex flex-col gap-4'>
          <div className='flex items-center gap-3 flex-wrap'>
            <p>
              Serviços permitidos:
            </p>

            {Number(establishmentCompany?.company_product_categories?.length) > 0 ? establishmentCompany?.company_product_categories?.map(({ product_category }, i) => (
              <div key={`product_category_${i}`} className='flex items-center gap-1 text-white-400'>
                <SquareCheckIcon strokeWidth={1.5} />

                <p className='text-white-800'>
                  {product_category.display_name}
                </p>
              </div>
            )) : (
              <p className='italic font-light'>
                Não possui
              </p>
            )}
          </div>

          <div className='flex items-center gap-3'>
            <p>
              Gestor responsável:
            </p>

            <div className='flex items-center gap-1 text-white-400'>
              <CircleChevronDownIcon strokeWidth={1.5} />

              <p className='text-white-800'>
                {establishmentCompany?.commercial_manager ? establishmentCompany.commercial_manager.full_name : '--'}
              </p>
            </div>
          </div>

          <div className='flex items-center gap-3'>
            <p>
              Fuso horário da empresa:
            </p>

            <div className='flex items-center gap-1 text-white-400'>
              <CircleChevronDownIcon strokeWidth={1.5} />

              <p className='text-white-800'>
                {establishmentCompany?.time_zone
                  ? `${establishmentCompany?.time_zone?.display_name} (GMT${formatTimezoneAcronym(establishmentCompany?.time_zone?.acronym)})`
                  : '--'}
              </p>
            </div>
          </div>

          <div className='flex items-center gap-3'>
            <p>
             Estorno via POS:
            </p>

            <div className='flex items-center gap-1 text-white-400'>
              {establishmentCompany?.allows_refunds_via_pos ? <SquareCheckIcon /> : <SquareX />}

              <p className='text-white-800'>
                {establishmentCompany?.allows_refunds_via_pos ? 'Ativo' : 'Inativo'}
              </p>
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default GeneralPoliticsSection;
